import { forwardRef } from "react";
import { SVGFillRect, SVGIconRoot } from "./SVGComponents";
import { IconProps } from "./index";

export const Minus = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <SVGIconRoot viewBox="0 0 20 4" ref={ref} {...props}>
      <SVGFillRect
        x="0.270264"
        y="0.0540466"
        width="19.4595"
        height="3.89189"
      />
    </SVGIconRoot>
  );
});
